var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewMsg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0882 22.9354H14.3759L14.5898 22.743L19.8645 17.9969L20.1128 17.7734V17.4394V3.15834C20.1128 2.28926 19.7445 1.67086 19.2221 1.2982C18.745 0.957797 18.1964 0.860765 17.8169 0.869065H3.36244C2.56131 0.80729 1.9655 1.1251 1.61415 1.63742C1.30528 2.0878 1.23631 2.61142 1.25216 2.96341V20.4751V20.4831L1.25233 20.491C1.2729 21.4653 1.63434 22.1603 2.21151 22.566C2.72253 22.9252 3.30295 22.9861 3.71504 22.9354H14.0882Z",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3789 17.6106H19.0721",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3789 21.9291V17.6533",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41113 4.9541H16.7463",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41113 8.37427H16.7463",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41113 11.5815H16.7463",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89648 15.0449L16.6216 15.0449",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89648 18.4224H12.053",
    stroke: "#202124",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0849 15.4763C7.06515 15.6259 7.01826 15.7606 6.94422 15.8802C6.87511 15.9999 6.78626 16.1068 6.67767 16.2008C6.56907 16.2906 6.44567 16.3675 6.30746 16.4316C6.16924 16.4915 6.0261 16.5385 5.87801 16.5727L7.64762 18.5923H6.80354L5.493 17.0856C5.34985 16.9189 5.21904 16.7992 5.10057 16.7265C4.98704 16.6496 4.86611 16.6111 4.73777 16.6111V16.1431H5.17461C5.32763 16.1431 5.47325 16.1346 5.61146 16.1175C5.75461 16.0961 5.88295 16.0619 5.99648 16.0149C6.11001 15.9636 6.2038 15.8952 6.27784 15.8097C6.35682 15.7242 6.40371 15.6131 6.41852 15.4763H4.60449L4.82662 15.0981H6.3889C6.34448 14.9228 6.24822 14.7818 6.10014 14.6749C5.95206 14.5681 5.75214 14.5104 5.5004 14.5018H4.60449L4.82662 14.1235H8.07706L7.85493 14.5018H6.77392C6.94175 14.6642 7.04294 14.863 7.07749 15.0981H8.07706L7.85493 15.4763H7.0849Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMsg);
export default __webpack_public_path__ + "static/media/viewMsg.feed71ad6baf44f5f41e22405ff8ed97.svg";
export { ForwardRef as ReactComponent };